import { render, staticRenderFns } from "./CommodityStatus.vue?vue&type=template&id=1ffcbdc9&scoped=true"
import script from "./CommodityStatus.vue?vue&type=script&lang=js"
export * from "./CommodityStatus.vue?vue&type=script&lang=js"
import style0 from "./CommodityStatus.vue?vue&type=style&index=0&id=1ffcbdc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffcbdc9",
  null
  
)

export default component.exports